import { render, staticRenderFns } from "./skillslist.vue?vue&type=template&id=6e92b066&"
import script from "./skillslist.vue?vue&type=script&lang=js&"
export * from "./skillslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports